import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelAllocation from "@/models/BaseModelAllocation.js"
import apiUtil from "@/services/apiUtil.js";
import jsonUtil from "@/services/jsonUtil.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";
import Vue from 'vue';

//for testing fetching more 5000 records in UAT
// import TestAPIFetch  from "@/models/BaseModelTestAPIFetch.js";
import BaseModelInvestmentValuation from "@/models/BaseModelInvestmentValuation.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelVestingSchedule from "@/models/BaseModelVestingSchedule.js";
import BaseModelAllocationReport from "@/models/BaseModelAllocationReport.js";

import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import BaseModelIssuance from "@/models/BaseModelIssuance.js";
import BaseModelTransfer from "@/models/BaseModelTransfer.js";
import BaseModelVesting from "@/models/BaseModelVesting.js";
import BaseModelDocument from "@/models/BaseModelDocument.js";
import BaseModelAuditUploadDocument from "@/models/BaseModelAuditUploadDocument.js";
import BaseModelUnitRunningTotal from "@/models/BaseModelUnitRunningTotal.js";
import BaseModelDirectInvestmentValuation from "@/models/BaseModelDirectInvestmentValuation.js";
import BaseModelTransactionLog from "@/models/BaseModelTransactionLog.js";
import BaseBusinessEventRunningTotal from "@/models/BaseBusinessEventRunningTotal.js";
import BaseModelBuyout from "@/models/BaseModelBuyout.js";

import BaseModelInformationTracking from "@/models/BaseModelInformationTracking.js";
import BaseModelDistribution from "@/models/BaseModelDistribution.js";
import BaseModelFMVStatementFootnote from '@/models/BaseModelFMVStatementFootnote.js';
import BaseModelFootnote from "@/models/BaseModelFootnote.js";
import BaseModelFMVStatementReport from "@/models/BaseModelFMVStatementReport.js";
import BaseModelPartnerAffiliation from "@/models/BaseModelPartnerAffiliation.js";
import BaseModelCorrection from "@/models/BaseModelCorrection.js";
import BaseModelCorrectionLog from "@/models/BaseModelCorrectionLog.js";
import BaseModelMemo from "@/models/BaseModelMemo.js";
import BaseModelCountries from "@/models/BaseModelCountries.js";
import BaseModelStates from "@/models/BaseModelStates.js";
import BaseModelPowerBIReport from "@/models/BaseModelPowerBIReport.js"

import router from '@/router'

const state = {
   initialGetHasBeenCalled: false,
   arraysPopulated: false,
   listStatuses: [],
   listStatus: {initialized: false, success: false},
   bundledObject: {
        Program: {
            config: BaseModelProgram
        },
        Partner: {
            config: BaseModelPartner
        },
        DirectInvestmentValuation: {
            config: BaseModelDirectInvestmentValuation
        },
        // TestAPIFetch:{
        //     config:TestAPIFetch
        // },
        Buyout: {
            config: BaseModelBuyout
        },
        UnitRunningTotal: {
            config: BaseModelUnitRunningTotal
        },
        BusinessEventRunningTotal: {
            config: BaseBusinessEventRunningTotal
        },
        Investment: {
            config: BaseModelInvestment
        },
        InvestmentValuation: {
            config: BaseModelInvestmentValuation
        },
        UnitClass: {
            config: BaseModelUnitClass
        },
        VestingSchedule: {
            config: BaseModelVestingSchedule
        },
        AllocationReport:
        {
            config:BaseModelAllocationReport 
        },
        // Transaction: {
        //     config: BaseModelTransaction
        // },
        InputControl: {
            config: BaseModelInputControl
        },
        Issuance: {
            config: BaseModelIssuance
        },
        Transfer: {
            config: BaseModelTransfer
        },
        Vesting: {
            config: BaseModelVesting
        },
        Documents: {
            config: BaseModelDocument
        },
        BulkUploadAudit: {
            config: BaseModelAuditUploadDocument
        },
        TransactionLog: {
            config: BaseModelTransactionLog
        },
        Allocation:
        {
            config: BaseModelAllocation
        },
        Distribution: {
            config: BaseModelDistribution
        },
        InformationTracker: {
            config: BaseModelInformationTracking
        },
        FMVStatementFootnote: {
            config: BaseModelFMVStatementFootnote
        },
        Footnote: {
            config: BaseModelFootnote
        },
        FMVStatementReport: {
            config: BaseModelFMVStatementReport
        },
        PartnerAffiliation: {
            config: BaseModelPartnerAffiliation
        },
        // Correction:{
        //     config: BaseModelCorrection
        // },
        // CorrectionLog:{
        //     config: BaseModelCorrectionLog
        // },
        FMVStatementMemo:{
            config: BaseModelMemo
        },
        Countries:{
            config: BaseModelCountries
        },
        States:{
            config: BaseModelStates
        },
        PowerBIReport:{
            config:BaseModelPowerBIReport
        }

    },
    DirectInvestmentValuation: [],
    Buyout: [],
    UnitRunningTotal: [],
    BusinessEventRunningTotal: [],
    Investment: [],
    InvestmentValuation: [],
    Program: [],
    Partner: [],
    UnitClass: [],
    VestingSchedule: [],
    InputControl: [],
    Issuance: [],
    Transfer: [],
    Vesting: [],
    TransactionLog: [],
    Documents: [],
    BulkUploadAudit:[],
    Distribution: [],
    InformationTracker: [],
    FMVStatementFootnote: [],
    Footnote: [],
    FMVStatementReport: [],
    PartnerAffiliation: [],
    response: '',
    errorMsg: '',
    CommonCollection: [],
    // Correction:[],
    // CorrectionLog:[],
    FMVStatementMemo:[],
    Countries:[],
    States:[],
    // TestAPIFetch:[],
    PowerBIReport:[]
}
const mutations = {
    // Initial Set All list
    SET_OBJ: (state, payload) => {
        Object.keys(payload).forEach((key) => {
            Vue.set(state, key, payload[key]);
        })
       // //console.log(state);
    },
    SET_ARRAYS_POPD: (state, value) => {
        state.arraysPopulated = value;
    },
    SET_ERR: (state, msg) => {
        state.errorMsg = msg;
    },
    SET_COLLECTION: (state, object) => {
        if(state.CommonCollection.findIndex(f => f.key == object.key) > -1){
            state.CommonCollection.filter(f => f.key == object.key)[0].value = object.value;
        }else{
            state.CommonCollection.push(object);
        }
    },
    INIT_LIST(state,object){
       //console.log(`PUSHING LIST ${object.list} TO INITIALIZED LIST`) 
       state.listStatuses.push(object.list)
      
    },
    SET_INIT_GET_CALLED(state,value){
        Vue.set(state,'initialGetHasBeenCalled',true);
     },
     SET_PROGRAM_LIST(value) {

        Vue.set(this.state,'Program',value);
     }
}

const getters = {
    // id_token: (state) => {
    //     return state.id_token;
    // },
    // querying the list data.
   
    bundledObject: (state) => state.bundledObject,
    getAll: (state) => (list) => {
        if (!Object.keys(state).some(key => key === list))
            return null;
        
        return state[list];
    },
    withFilter: (state) => (list, query) => {
        query = jsonUtil.methods._QueryStringToJSON(query);
        return _.filter(state[list], query);
    },
    getAllItemFilter: (state) => (bundledObject) => {
        const lists = Object.keys(bundledObject);
        const props = Object.values(bundledObject);
        const resources = _.zipObject(lists, props.map(object => _.filter(state[object.config.list], jsonUtil.methods._QueryStringToJSON(object.query))));
        return _.zipObject(Object.keys(resources), (Object.values(resources)));
    },
    getJoinedItemsFilter: (state) => (joinedObject) => {
        joinedObject.keyToJoin = joinedObject.keyToJoin.replace(/\\/g, '')
        let query = {
            filter: `${joinedObject.keyToJoin} eq ${joinedObject.parentId}`
        }
        query = jsonUtil.methods._QueryStringToJSON(query);

        //Parent Items
        let parentQuery = {
            filter: `Id eq ${joinedObject.parentId}`
        }
        parentQuery = jsonUtil.methods._QueryStringToJSON(parentQuery);

        //child items
        const lists = joinedObject.childConfigs.map(config => config.list);
        const props = Object.values(joinedObject.childConfigs);
        const resources = _.zipObject(lists, props.map(object => _.filter(state[object.list], query)));
        return {
            parent: _.filter(state[joinedObject.parentConfig.list], parentQuery)[0],
            children: _.zipObject(Object.keys(resources), (Object.values(resources)))
        };
    },

    isListReady: (state) => (listName) => {
        const res = state.listStatuses.filter(f => f == listName);
        if (res.length != 0) {
            return true;
        } else {
            return false;
        }
    },
    listHasData: (state) => (listName) => {
       if ( state[listName] != undefined){

            if (state[listName].length > 0){
                return true;
            } else {
                return false;
            }

       }
    },
    getLocalInputControls: (state) => (list, key) => {
        const key2 = (key) ? key : 'Field';
        const response = state[list];
        return _.groupBy(response, key2);
    },

    GetValueByKey: (state) => (key) => {
        const res = state.CommonCollection.filter(f => f.key == key);
        if (res.length != 0) {
            return res[0].value
        } else {
            return ''
        }
    },

    RemoveValueByKey: (state) => (key) => {
        state.CommonCollection.splice(state.CommonCollection.findIndex(f => f.key == key), 1);
    },

    ListArraysPopulated: () => {
        return state.arraysPopulated;
    },

    ListStatus: () => {
        return state.listStatus;
    },
    ListStatuses: () => {
        return state.listStatuses;
    },
    InitialGetCalled: () => {
        return state.initialGetHasBeenCalled;
    }
    
}

const actions = {
_setInitialGetCalled: (state) => (value) => {
  state.commit("SET_INIT_GET_CALLED",value);

},
//  _addListDataToStore: (state) => (listName, object) => {
//         const res = state.bundledObject.filter(f => f == listName);
//         if (res.length != 0) {
            
//                 // commit the list here

//         } else {
//             return false;
//         }
//     },
    // async _getItems2(state,config){
    //     let self = this;
    //    let res = await apiUtil.methods._getItems(config);
    //    //console.log(`MAKE ENTRY IN STORE - ${config.list} - is initialized`)
    //    state.commit('INIT_LIST', config, res)
    //    //state.commit('')
    //    return; 


    // },

    async GetAllItemsUnbundled(state) {
       // //console.log('getModule gGetAllItemsUnbundled CALLED');
        let self = this;
      state.commit("SET_INIT_GET_CALLED",true);
      //console.log(`bundledObject `, state.state.bundledObject);
      let llist = state.state.bundledObject
      

      const mapTest = new Map(
        Object.entries(llist).map(
            ([key, value]) => [key, value["config"]]
        )
        
    );
    [...mapTest.keys()].forEach(key => {
            let thisone = mapTest.get(key);
           // //console.log(`about to dispatch GetItems for ${thisone}` );
            self.dispatch('getModule/GetItems',thisone);
        })

    },
   

    async GetAllItems(state) {
        return apiUtil.methods._getAllItems(state.state.bundledObject).then((response) => {
               // //console.log(response);
                state.commit("SET_OBJ", response);
                state.commit("SET_ARRAYS_POPD",true);
            })
            .catch((error) => {
                state.commit("SET_OBJ", []);
                state.commit("SET_ERR", error);
                router.push({
                    path: "/pagenotfound"
                })
            })
            .finally(() => {})
    },

    // get update multiple list item data API call
    async GetUpdatedItems(state, updatedItems) {
        Object.keys(updatedItems).forEach((key) => {
            updatedItems[key].config = state.state.bundledObject[key].config;
        })
        return apiUtil.methods._getAllItems(updatedItems).then((res) => {
                state.commit("SET_OBJ", res);
            })
            .catch((error) => {
                state.commit("SET_OBJ", []);
            })
            .finally(() => {})
    },

    // get single list item data API call.
    async GetItems(state, config) {
        //console.log(`[getModule.js] GetItems running for ${config.list}`)
        let respList = await apiUtil.methods._getItems({list: config.list});
                state.commit("SET_OBJ", {
                    [config.list]: respList
                });
             return respList;
     },
     
    async GetItemsWithFlag(state,config){
       let self = this;
       const listConfig = state.state.bundledObject[config.list].config;
       await apiUtil.methods._getItems(config);
       if(state.getters.ListStatuses.findIndex(f => f == config.list) == -1){
          state.commit("INIT_LIST",listConfig);
       }
       return; 


    },
    AddCollection(state, config) {
        state.commit("SET_COLLECTION", config);
    },
    SetProgramList(listobject){

        this.state.SET_PROGRAM_LIST(listobject);
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};